module.exports = __webpack_public_path__ + "static/media/qr-scanner_p2_2.95d05308.png";